'use strict';

var dashboardSharingTooltip = require('./dashboardSharingTooltip');
var dashboardSharingPopover = require('./dashboardSharingPopover');
var dashboardProgressStatus = require('./dashboardProgressStatus');
var dashboardManageCompetitors = require('./dashboardManageCompetitors');

require('./dashboardDatePicker');
require('../../pdf/downloadPdf');
require('./dashboardShortURL');

dashboardManageCompetitors();

if ($('#dashboard-bars').length > 0) {
  dashboardProgressStatus();
}

dashboardSharingPopover();
dashboardSharingTooltip();
